
function Footer(props){

  return (
    <footer>
      &copy; 2022~2023. Baik Seung Yoon. All rights reserved.
    </footer>
  )
}

export default Footer;